export type Coord3 = [number, number, number?];

export interface RouteInstruction {
  sign: number;
  street_name: string;
  distance_m: number;
  time_ms: number;
  interval: [number, number];
  exit_number?: number;
  exited?: boolean;
  turn_angle?: number;
  text?: string;
}

export interface RouteFeature {
  type: 'Feature';
  geometry: { type: 'LineString'; coordinates: Coord3[] };
  properties: {
    route_num: number;
    name: string;
    color?: string;
    distance_km?: number;
    distance_km_precise?: number;
    duration_h?: number;
    ascend_m?: number;
    descend_m?: number;
    short_name?: string;
    destination_label?: string;
    via?: string;
    dynamic?: boolean;
    provider?: string;
    saved_at?: string;
    markers?: Array<{ label: string; coordinates: [number, number] }>;
    details?: Record<string, Array<[number, number, string | number | boolean | null]>>;
    instructions?: RouteInstruction[];
  };
}

export interface RoutesGeoJson {
  type: 'FeatureCollection';
  features: RouteFeature[];
}

export interface FuelFeature {
  type: 'Feature';
  geometry: { type: 'Point'; coordinates: [number, number] };
  properties: {
    id?: string;
    n?: string;
    c?: string;
    a?: string;
    p?: number;
    r?: number;
    u?: string;
    ft?: string;
    bk?: string;
    rb?: string;
    bc?: string;
    bs?: string;
  };
}

export interface FuelGeoJson {
  type: 'FeatureCollection';
  metadata?: { updated?: string; count?: number; units?: string[] };
  features: FuelFeature[];
}

export interface TollFeature {
  type: 'Feature';
  geometry: { type: 'Point'; coordinates: [number, number] };
  properties: Record<string, unknown>;
}

export interface TollGeoJson {
  type: 'FeatureCollection';
  metadata?: {
    source?: string;
    live_route_nums?: number[];
    reused_existing_route_nums?: number[];
    unavailable_route_nums?: number[];
  };
  features: TollFeature[];
}

export type TrackingMode = 'off' | 'locate' | 'follow';
export type UiMode = 'auto' | 'day' | 'night';
export const LANGUAGE_CODES = ['EN', 'DE', 'ES', 'IT', 'FR'] as const;
export type LanguageCode = typeof LANGUAGE_CODES[number];
export type UnitSystem = 'metric' | 'imperial';
export type BasemapOverride = 'satellite' | 'light' | 'dark' | 'bright' | 'orbita' | 'black' | 'white';
export type PriceMode = 'local' | 'eur_l';
export type FuelType = 'diesel' | 'gasoline_95' | 'gasoline_98' | 'diesel_premium' | 'lpg';
export type TrafficStyle = 'relative0' | 'relative0-dark' | 'relative-delay' | 'absolute';
export type DifficultyMode = 'slope' | 'curves' | 'hairpins';
export type WindLevel = 'surface' | '850' | '500';
export type ProfileColorMode = 'elevation' | 'max_speed' | 'average_speed' | 'road_class' | 'surface' | 'country' | 'toll' | 'road_environment' | 'road_access' | 'lanes';
